import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '../models/resource.model';

/**Pipe che gestisce la verifica delle autorizzazioni per modificare una traduzione */
@Pipe({
  name: 'editableTranslation'
})
export class EditableTranslationPipe implements PipeTransform {

  /**
   * Metodo dell'interfaccia PipeTransform che controlla se abilitare la modifica
   * @param indiceTrad {string} indice puntato della traduzione di cui valutare le autorizzazioni
   * @param ruoloLoggedUser {string} ruolo dell'utente loggato
   * @param risorseAssegnate {Resource[]} elenco delle risorse assegnate all'utente loggato
   * @param isTradLocked {boolean} la traduzione è o meno bloccata
   */
  transform(indiceTrad: string, ruoloLoggedUser: string, risorseAssegnate: Resource[], isTradLocked: boolean): boolean { 
    let editableResult = false;
    if (ruoloLoggedUser !== 'Viewer' && !isTradLocked) {
      if (ruoloLoggedUser === 'Administrator' || ruoloLoggedUser === 'Supervisor') {
        editableResult = true;
      } else if(risorseAssegnate.length > 0) {
        let elementiIndiceTrad = indiceTrad.split('.');
        let risorseAssegnateCopy = risorseAssegnate.filter(risorsa => {
          let indiceRisorsa = risorsa.index.split('.');
          if(indiceRisorsa.length === 1) {
            return indiceRisorsa[0] === elementiIndiceTrad[0];
          } else {
            return indiceRisorsa[0] === elementiIndiceTrad[0] && indiceRisorsa[1] === elementiIndiceTrad[1];
          }
        });
        editableResult = risorseAssegnateCopy.length > 0 ? true : false;
      }
    }
    return editableResult;
  }

}
